import { Dictionary } from './dictionary'
import { Owner } from './user'

export class NoteSimple {
  id: number
  title: string
}

export class Note {
  id: number
  owner: Owner
  title: string
  text: string
  dictionaries: Dictionary[]
  dictionaries_count: number
  likes: number
  is_liked: boolean
  bookmarks: number
  is_bookmarked: boolean
  is_mine: boolean
  created_at: string
  last_update: string
  time_since_creation: string
  slug: string | null
  ai_generated: boolean
  privacy: string
}
